/**
 * Shared inline SVG icon helpers.
 *
 * Kept as string-returning functions (not components) so they can be
 * interpolated directly into the innerHTML templates the sections build.
 *
 * @module utils/icons
 */

/**
 * Small up-and-to-the-right arrow used on clickable session tags
 * (e.g. the /practices and /discovery detail-panel "Session N ↗" pills).
 * @returns {string} Inline SVG markup
 */
export function iconArrowUpRight() {
  return `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
      <path d="M3 7L7 3M7 3H4M7 3V6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
}

/**
 * Small right-pointing arrow used on inline "Learn more …" links (the
 * pattern detail's education hand-off).
 * @returns {string} Inline SVG markup
 */
export function iconArrowRight() {
  return `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path d="M2.5 6H9.5M9.5 6L6.5 3M9.5 6L6.5 9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
}
